import { WORLD_WIDTH, WORLD_HEIGHT } from 'asteroids-shared/constants';
import { hashString, mulberry32 } from 'asteroids-shared/helpers';

const STAR_COLORS = ['#ffffff', '#d7ecff', '#fff3c4'];

export default class Starfield {
  constructor({ seedText, worldWidth = WORLD_WIDTH, worldHeight = WORLD_HEIGHT }) {
    this.worldWidth = worldWidth;
    this.worldHeight = worldHeight;
    this.seedText = null;
    this.buffer = null;
    this.rebuild(seedText);
  }

  rebuild(seedText = '') {
    if (seedText === this.seedText && this.buffer) return;

    this.seedText = seedText;
    this.buffer = document.createElement('canvas');
    this.buffer.width = this.worldWidth;
    this.buffer.height = this.worldHeight;

    const ctx = this.buffer.getContext('2d');
    const rng = mulberry32(hashString(seedText || 'asteroids'));
    const starCount = Math.max(
      90,
      Math.min(160, Math.round((this.worldWidth * this.worldHeight) / 50000))
    );

    ctx.clearRect(0, 0, this.worldWidth, this.worldHeight);

    for (let i = 0; i < starCount; i++) {
      const x = Math.floor(rng() * this.worldWidth);
      const y = Math.floor(rng() * this.worldHeight);
      const size = rng() > 0.9 ? 2 : 1;
      const alpha = 0.35 + rng() * 0.55;
      const color = STAR_COLORS[Math.floor(rng() * STAR_COLORS.length)];

      ctx.fillStyle = color;
      ctx.globalAlpha = alpha;
      ctx.fillRect(x, y, size, size);
    }

    ctx.globalAlpha = 1;
  }

  draw(ctx, camera) {
    if (!this.buffer) return;

    let sourceY = ((camera.y % this.worldHeight) + this.worldHeight) % this.worldHeight;
    let destY = 0;
    let remainingHeight = camera.viewH;

    while (remainingHeight > 0) {
      const sliceHeight = Math.min(this.worldHeight - sourceY, remainingHeight);
      let sourceX = ((camera.x % this.worldWidth) + this.worldWidth) % this.worldWidth;
      let destX = 0;
      let remainingWidth = camera.viewW;

      while (remainingWidth > 0) {
        const sliceWidth = Math.min(this.worldWidth - sourceX, remainingWidth);
        ctx.drawImage(
          this.buffer,
          sourceX, sourceY, sliceWidth, sliceHeight,
          destX, destY, sliceWidth, sliceHeight
        );
        remainingWidth -= sliceWidth;
        destX += sliceWidth;
        sourceX = 0;
      }

      remainingHeight -= sliceHeight;
      destY += sliceHeight;
      sourceY = 0;
    }
  }
}
